import { useEffect, useState } from 'react'
import Layout from '../../components/Layout'
import Toast from '../../utils/toast'
import './style.css'
import { createMultiLogin, getMultiLoginList } from '@/services/multiLoginApi'

/**
 * MultiLogin Component
 * 
 * Page for creating multi-login accounts with privileges.
 */
function MultiLogin() {
  const [formData, setFormData] = useState({
    clientId: '',
    fullName: '',
    password: '',
    confirmPassword: '',
    mpass: ''
  })

  const [privileges, setPrivileges] = useState({
    all: false,
    currentBets: false,
    loginUserCreation: false,
    betLock: false,
    dashboard: true, // Default checked
    generalLock: false,
    withdraw: false,
    activeUser: false,
    marketAnalysis: false,
    casinoResult: false,
    deposit: false,
    agentAssign: false,
    userList: false,
    liveCasinoResult: false,
    creditReference: false,
    insertUser: false,
    ourCasino: false,
    userInfo: false,
    accountStatement: false,
    events: false,
    userPasswordChange: false,
    partyWinLoss: false,
    marketSearchAnalysis: false,
    userLock: false
  })

  const [tableData] = useState([])
  const [loading, setLoading] = useState(false)

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  // Handle privilege checkbox change
  const handlePrivilegeChange = (privilege) => {
    setPrivileges(prev => ({
      ...prev,
      [privilege]: !prev[privilege]
    }))
  }

   useEffect(() => {
  fetchExecutives()
}, [])

  const fetchExecutives = async () => {
  try {
    const res = await getMultiLoginList()

    if (!res?.success) {
      Toast.fire({ icon: 'error', title: 'Failed to load executives' })
      return
    }

    const mapped = res.executives.map(exec => {
      const p = exec.permissions || {}

      return {
        action: exec.active ? 'Active' : 'Inactive',
        username: exec.username,
        fullName: exec.email || '-', // backend doesn’t send fullName yet

        dashboard: !!p.dashboard,
        marketAnalysis: !!p.marketAnalysis,
        userList: !!p.userList,
        insertUser: !!p.insertUser,
        accountStatement: !!p.accountStatement,
        partyWinLoss: !!p.partyWinLoss,
        currentBets: !!p.currentBets,
        generalLock: !!p.generalLock,
        casinoResult: !!p.casinoResult,
        liveCasinoResult: !!p.liveCasinoResult,
        our: !!p.ourCasino
      }
    })

    setTableData(mapped)
  } catch (err) {
    console.error(err)
    Toast.fire({
      icon: 'error',
      title: err.message || 'Error fetching executives'
    })
  }
}


  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault()

    // Validation
    if (!formData.clientId || !formData.fullName || !formData.password || !formData.confirmPassword) {
      Toast.fire({
        icon: 'error',
        title: 'Please fill in all required fields'
      });
      return
    }

    if (formData.password !== formData.confirmPassword) {
      Toast.fire({
        icon: 'error',
        title: 'Password and Confirm Password do not match'
      });
      return
    }

    if (!formData.mpass) {
      Toast.fire({
        icon: 'error',
        title: 'Please enter Transaction Code'
      });
      return
    }

    setLoading(true)
    try {
      // Transform privileges object to permissions format
      const payload = {
        username: formData.clientId,
        password: formData.password,
        permissions: privileges
      }

      const response = await createMultiLogin(payload)
      
      Toast.fire({
        icon: 'success',
        title: response.message || 'Multi Login account created successfully'
      });

      // Reset form
      setFormData({
        clientId: '',
        fullName: '',
        password: '',
        confirmPassword: '',
        mpass: ''
      })
      setPrivileges({
        all: false,
        currentBets: false,
        loginUserCreation: false,
        betLock: false,
        dashboard: true,
        generalLock: false,
        withdraw: false,
        activeUser: false,
        marketAnalysis: false,
        casinoResult: false,
        deposit: false,
        agentAssign: false,
        userList: false,
        liveCasinoResult: false,
        creditReference: false,
        insertUser: false,
        ourCasino: false,
        userInfo: false,
        accountStatement: false,
        events: false,
        userPasswordChange: false,
        partyWinLoss: false,
        marketSearchAnalysis: false,
        userLock: false
      })
    } catch (error) {
      console.error('Error creating multi login account:', error)
      Toast.fire({
        icon: 'error',
        title: 'Failed to create account: ' + (error.message || 'Unknown error occurred')
      });
    } finally {
      setLoading(false)
    }
  }

  // Handle reset
  const handleReset = () => {
    setFormData({
      clientId: '',
      fullName: '',
      password: '',
      confirmPassword: '',
      mpass: ''
    })
    setPrivileges({
      all: false,
      currentBets: false,
      loginUserCreation: false,
      betLock: false,
      dashboard: true,
      generalLock: false,
      withdraw: false,
      activeUser: false,
      marketAnalysis: false,
      casinoResult: false,
      deposit: false,
      agentAssign: false,
      userList: false,
      liveCasinoResult: false,
      creditReference: false,
      insertUser: false,
      ourCasino: false,
      userInfo: false,
      accountStatement: false,
      events: false,
      userPasswordChange: false,
      partyWinLoss: false,
      marketSearchAnalysis: false,
      userLock: false
    })
  }

  return (
    <Layout title="Multi Login Account - Diamond Admin">

      <div>
        <h4 className="mb-0 page-title-box">
          Multi Login Account
        </h4>
        <div className="l">

          <div className="account-list-multi-login">
            {/* Page Title */}
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-flex align-items-center justify-content-between">

                </div>
              </div>
            </div>

            {/* Form Section */}
            <div className="row">
              <div className="col-12">
                <div className="">
                  <div className="">
                    <form onSubmit={handleSubmit}>
                      <div className="create-account-form">
                        {/* Personal Information Section */}
                        <div className="row mb-4">
                          <div className="col-12">
                            <h5 className="mb-3">Personal Information</h5>
                          </div>
                          <div className="col-md-3 mb-3">
                            <label htmlFor="clientId">
                              Client ID
                            </label>
                            <input
                              type="text"
                              id="clientId"
                              name="clientId"
                              className="form-control"
                              value={formData.clientId}
                              onChange={handleChange}
                              required
                            />
                          </div>
                          <div className="col-md-3 mb-3">
                            <label htmlFor="fullName">
                              Full Name
                            </label>
                            <input
                              type="text"
                              id="fullName"
                              name="fullName"
                              className="form-control"
                              value={formData.fullName}
                              onChange={handleChange}
                              required
                            />
                          </div>
                          <div className="col-md-3 mb-3">
                            <label htmlFor="password">
                              Password
                            </label>
                            <input
                              type="password"
                              id="password"
                              name="password"
                              className="form-control"
                              value={formData.password}
                              onChange={handleChange}
                              required
                            />
                          </div>
                          <div className="col-md-3 mb-3">
                            <label htmlFor="confirmPassword">
                              Confirm Password
                            </label>
                            <input
                              type="password"
                              id="confirmPassword"
                              name="confirmPassword"
                              className="form-control"
                              value={formData.confirmPassword}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>

                        {/* Privileges Section */}
                        <div className="mt-2 previlages">
                          <h5 className="mb-0">Privileges</h5>
                          <div className="previlage-box">
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="true"
                                    id="privilege-all"
                                    checked={privileges.all}
                                    onChange={() => handlePrivilegeChange('all')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-all">
                                    All
                                  </label>
                                </div>
                              </div>
                            </div>
                            <br />
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="1"
                                    id="privilege-dashboard"
                                    checked={privileges.dashboard}
                                    onChange={() => handlePrivilegeChange('dashboard')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-dashboard">
                                    DashBoard
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="2"
                                    id="privilege-marketAnalysis"
                                    checked={privileges.marketAnalysis}
                                    onChange={() => handlePrivilegeChange('marketAnalysis')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-marketAnalysis">
                                    Market Analysis
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="4"
                                    id="privilege-userList"
                                    checked={privileges.userList}
                                    onChange={() => handlePrivilegeChange('userList')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-userList">
                                    User List
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="5"
                                    id="privilege-insertUser"
                                    checked={privileges.insertUser}
                                    onChange={() => handlePrivilegeChange('insertUser')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-insertUser">
                                    Insert User
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="8"
                                    id="privilege-accountStatement"
                                    checked={privileges.accountStatement}
                                    onChange={() => handlePrivilegeChange('accountStatement')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-accountStatement">
                                    Account Statement
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="9"
                                    id="privilege-partyWinLoss"
                                    checked={privileges.partyWinLoss}
                                    onChange={() => handlePrivilegeChange('partyWinLoss')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-partyWinLoss">
                                    Party Win Loss
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="10"
                                    id="privilege-currentBets"
                                    checked={privileges.currentBets}
                                    onChange={() => handlePrivilegeChange('currentBets')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-currentBets">
                                    Current Bets
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="12"
                                    id="privilege-generalLock"
                                    checked={privileges.generalLock}
                                    onChange={() => handlePrivilegeChange('generalLock')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-generalLock">
                                    General Lock
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="13"
                                    id="privilege-casinoResult"
                                    checked={privileges.casinoResult}
                                    onChange={() => handlePrivilegeChange('casinoResult')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-casinoResult">
                                    Casino Result
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="14"
                                    id="privilege-liveCasinoResult"
                                    checked={privileges.liveCasinoResult}
                                    onChange={() => handlePrivilegeChange('liveCasinoResult')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-liveCasinoResult">
                                    Live Casino Result
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="15"
                                    id="privilege-ourCasino"
                                    checked={privileges.ourCasino}
                                    onChange={() => handlePrivilegeChange('ourCasino')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-ourCasino">
                                    Our Casino
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="16"
                                    id="privilege-events"
                                    checked={privileges.events}
                                    onChange={() => handlePrivilegeChange('events')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-events">
                                    Events
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="17"
                                    id="privilege-marketSearchAnalysis"
                                    checked={privileges.marketSearchAnalysis}
                                    onChange={() => handlePrivilegeChange('marketSearchAnalysis')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-marketSearchAnalysis">
                                    Market Search Analysis
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="19"
                                    id="privilege-loginUserCreation"
                                    checked={privileges.loginUserCreation}
                                    onChange={() => handlePrivilegeChange('loginUserCreation')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-loginUserCreation">
                                    Login User creation
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="54"
                                    id="privilege-withdraw"
                                    checked={privileges.withdraw}
                                    onChange={() => handlePrivilegeChange('withdraw')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-withdraw">
                                    Withdraw
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="55"
                                    id="privilege-deposit"
                                    checked={privileges.deposit}
                                    onChange={() => handlePrivilegeChange('deposit')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-deposit">
                                    Deposit
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="56"
                                    id="privilege-creditReference"
                                    checked={privileges.creditReference}
                                    onChange={() => handlePrivilegeChange('creditReference')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-creditReference">
                                    Credit Reference
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="57"
                                    id="privilege-userInfo"
                                    checked={privileges.userInfo}
                                    onChange={() => handlePrivilegeChange('userInfo')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-userInfo">
                                    User Info
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="58"
                                    id="privilege-userPasswordChange"
                                    checked={privileges.userPasswordChange}
                                    onChange={() => handlePrivilegeChange('userPasswordChange')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-userPasswordChange">
                                    User Password Change
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="59"
                                    id="privilege-userLock"
                                    checked={privileges.userLock}
                                    onChange={() => handlePrivilegeChange('userLock')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-userLock">
                                    User Lock
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="60"
                                    id="privilege-betLock"
                                    checked={privileges.betLock}
                                    onChange={() => handlePrivilegeChange('betLock')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-betLock">
                                    Bet Lock
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="91"
                                    id="privilege-activeUser"
                                    checked={privileges.activeUser}
                                    onChange={() => handlePrivilegeChange('activeUser')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-activeUser">
                                    active user
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="previlage-item">
                              <div>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    name="plist"
                                    className="custom-control-input"
                                    value="104"
                                    id="privilege-agentAssign"
                                    checked={privileges.agentAssign}
                                    onChange={() => handlePrivilegeChange('agentAssign')}
                                  />
                                  <label className="custom-control-label" htmlFor="privilege-agentAssign">
                                    Agent Assign
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="previlage-master mt-2">
                            <div className="form-group mb-0">
                              <input
                                type="password"
                                name="mpass"
                                placeholder="Transaction Code"
                                className="form-control mpass-text"
                                value={formData.mpass}
                                onChange={handleChange}
                                required
                              />
                              <button
                                type="submit"
                                className="btn btn-success"
                                disabled={loading}
                              >
                                {loading ? 'Submitting...' : 'Submit'}
                              </button>
                              <button
                                type="button"
                                id="reset"
                                className="btn btn-light"
                                onClick={handleReset}
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>

                    {/* Table Section */}
                    <div className="row mt-4">
                      <div className="col-12">
                        <div className="table-responsive">
                          <table className="table b-table table-bordered">
                            <thead>
                              <tr>
                                <th>Action</th>
                                <th>Username</th>
                                <th>Full Name</th>
                                <th>DashBoard</th>
                                <th>Market Analysis</th>
                                <th>User List</th>
                                <th>Insert User</th>
                                <th>Account Statement</th>
                                <th>Party Win Loss</th>
                                <th>Current Bets</th>
                                <th>General Lock</th>
                                <th>Casino Result</th>
                                <th>Live Casino Result</th>
                                <th>Our</th>
                              </tr>
                            </thead>
                            <tbody>
                              {tableData.length === 0 ? (
                                <tr>
                                  <td colSpan="14" className="text-center">
                                    No data available
                                  </td>
                                </tr>
                              ) : (
                                tableData.map((row, index) => (
                                  <tr key={index}>
                                    <td>{row.action || '-'}</td>
                                    <td>{row.username || '-'}</td>
                                    <td>{row.fullName || '-'}</td>
                                    <td>{row.dashboard ? '✓' : '-'}</td>
                                    <td>{row.marketAnalysis ? '✓' : '-'}</td>
                                    <td>{row.userList ? '✓' : '-'}</td>
                                    <td>{row.insertUser ? '✓' : '-'}</td>
                                    <td>{row.accountStatement ? '✓' : '-'}</td>
                                    <td>{row.partyWinLoss ? '✓' : '-'}</td>
                                    <td>{row.currentBets ? '✓' : '-'}</td>
                                    <td>{row.generalLock ? '✓' : '-'}</td>
                                    <td>{row.casinoResult ? '✓' : '-'}</td>
                                    <td>{row.liveCasinoResult ? '✓' : '-'}</td>
                                    <td>{row.our || '-'}</td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </Layout>
  )
}

export default MultiLogin

